import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-3" }
const _hoisted_2 = {
  key: 1,
  class: "_grid _grid-cols-3 _gap-2 _gap-3--m"
}
const _hoisted_3 = ["href", "data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_backer_center_recently_viewed_projects_skeleton = _resolveComponent("backer-center-recently-viewed-projects-skeleton")
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_text = _resolveComponent("base-text")
  const _component_icon_base_button = _resolveComponent("icon-base-button")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_base_title, { as: "h2" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.Resources.BackerCenter.SectionRecentlyViewedProjectsHeader), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      (_ctx.isProcessing)
        ? (_openBlock(), _createBlock(_component_backer_center_recently_viewed_projects_skeleton, { key: 0 }))
        : ($options.hasProjects)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mappedProjects, (project) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: project.projectID,
                  href: project.projectUrl,
                  "data-qa": project.dataQa
                }, [
                  _createVNode(_component_base_image, {
                    src: project.imageUrl,
                    alt: project.name,
                    class: "_rounded--common _bxsh--base",
                    loading: "lazy"
                  }, null, 8 /* PROPS */, ["src", "alt"])
                ], 8 /* PROPS */, _hoisted_3))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : (_openBlock(), _createBlock(_component_box, { key: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_empty_state, {
                  class: "gfu-box__content",
                  "show-divider": false,
                  "data-qa": "empty-state"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_text, { level: "b2" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.BackerCenter.RecentlyViewedProjectsEmptyStateHeader), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_base_text, { level: "b2" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.BackerCenter.RecentlyViewedProjectsEmptyStateParagraph), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_icon_base_button, {
                      tag: "a",
                      class: "gfu-btn gfu-btn--accent gfu-btn--soft _ttl _mt-3",
                      icon: "search",
                      href: $options.searchUrl,
                      "data-qa": "recently-viewed-project:ExploreProjectsButton"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.BackerCenter.UpdatesFeedEmptyStateButtonLabel), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["href"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }))
    ])
  ]))
}